(function() {
  'use strict';

  angular.module('component.blueprints')
    .component('blueprints', {
      templateUrl: 'app/components/blueprints/list.html',
      controller: 'BlueprintsController',
      controllerAs: 'blueprintsCtrl'
    });
})();
